import React, { useEffect, useState } from 'react';
import { CContainer, CButton } from '@coreui/react';
import { CIcon } from '@coreui/icons-react';
import { cilPlus } from '@coreui/icons';
import { useNavigate } from 'react-router-dom';
import YarnTable from '../../components/YarnTable/YarnTable';
import { getYarnRequestAction } from '../../store/yarn/yarnActions';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';

const Yarn = ({ yarnList, yarnData, getYarnRequest }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [query, setQuery] = useState({
    YarnName: null,
    YarnCode: null,
    YarnFactor: null,
    OrderBy: null,
    IsDescending: true,
    PageNumber: 1,
    PageSize: 10,
  });

  useEffect(() => {
    getYarnRequest(query);
  }, [getYarnRequest, query]);

  const handleFilterChange = (filters) => {
    setQuery((prev) => ({
      ...prev,
      ...filters,
      PageNumber: 1,
    }));
  };

  const handleSortChange = (orderBy, isDescending) => {
    setQuery((prev) => ({
      ...prev,
      OrderBy: orderBy,
      IsDescending: isDescending,
      PageNumber: 1,
    }));
  };

  const handlePageChange = (pageNumber) => {
    setQuery((prev) => ({
      ...prev,
      PageNumber: pageNumber,
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setQuery((prev) => ({
      ...prev,
      PageSize: pageSize,
      PageNumber: 1,
    }));
  };

  const handleCreateYarn = () => {
    navigate('/yarn/create');
  };

  return (
    <div className="yarn-page-container">
      <CContainer>
        <div className="text-fs-head-sm text-start mb-3">{t('yarns')}</div>
        <YarnTable
          yarnList={yarnList}
          yarnData={yarnData}
          query={query}
          onFilterChange={handleFilterChange}
          onSortChange={handleSortChange}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
        />
      </CContainer>

      <CButton
        color="primary"
        className="create-order-fab"
        onClick={handleCreateYarn}
        title={t('createNewYarn')}
      >
        <CIcon icon={cilPlus} size="lg" />
      </CButton>
    </div>
  );
};

const mapStateToProps = (state) => ({
  yarnData: state.yarnReducer.yarnData,
  yarnList: state.yarnReducer.yarnList,
});

const mapDispatchToProps = (dispatch) => ({
  getYarnRequest: (payload) => dispatch(getYarnRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Yarn);
